import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function PayButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Mark as Paid
    </Button>
  );
}
